import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const modalOpen = false;
class ModalContainer extends PureComponent {
  static isModalOpen() {
    return modalOpen;
  }

  _onEscapeClose = e => {
    e.stopPropagation();
    if (e.key === "Escape") {
      this._closeModal(e);
    }
  };

  _closeModal = e => {
    const { onClose } = this.props;
    onClose(e);
  };

  render() {
    const { className, children, onClose, ...otherProps } = this.props;

    return (
      <div
        role="button"
        className={`revv-modal-container ${className}`}
        tabIndex={0}
        onKeyDown={this._onEscapeClose}
        {...otherProps}>
        <div
          role="presentation"
          className="revv-modal"
          onClick={e => e.stopPropagation()}
          onKeyDown={null}>
          <div
            role="presentation"
            className="revv-close-normal revv-modal-close"
            onClick={this._closeModal}>
            <i className="icon-close">
              <FontAwesomeIcon icon={["far", "times"]} />
            </i>
          </div>
          <div className="revv-custom-scrollbar revv-modal-children">
            {children}
          </div>
        </div>
      </div>
    );
  }
}

ModalContainer.defaultProps = {
  className: "",
};

ModalContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModalContainer;



// WEBPACK FOOTER //
// ./src/commonComponents/Modal/ModalContainer.js